import * as rootActions from './root';
export var root = rootActions;
//# sourceMappingURL=index.js.map